import controller from './categories-filter.controller';
import template from './categories-filter.view.html';

let CategoriesFilterComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default CategoriesFilterComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/categories-filter/categories-filter.component.js
 **/